import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  '*': { boxSizing: 'border-box' },
  container: { height: '100%', display: 'flex', flexDirection: 'column' },
  doc_preview: { overflowY: 'auto', height: '100%', display: 'flex', justifyContent: 'center' },
  doc_footer: {
    padding: '1rem',
    background: 'white',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  doc_button: {
    backgroundColor: 'gray',
    color: 'white',
    height: '2.6rem',
    padding: '1rem 2.5rem'
  },
  modal_default: {
    width: '40rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '1rem 1rem 1.5rem'
  },
  modal_form: {
    display: 'flex',
    flexDirection: 'column',
    height: '17.5rem',
    width: '80%',
    justifyContent: 'space-evenly',
    top: '-1.2rem',
    position: 'relative'
  },
  modal_button: {
    backgroundColor: '#0A775A',
    color: 'white',
    width: '40%',
    alignSelf: 'center',
    '&:hover, &:focus': { backgroundColor: '#042f23' }
  },
  modal_response: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '5.3rem',
    justifyContent: 'space-between'
  },
  modal_input: {
    boxSizing: 'border-box',
    border: '#cdcdcd solid 0.1rem',
    borderRadius: '0.3rem',
    color: 'inherit',
    padding: '0.5rem 0.7rem',
    fontSize: '1rem',
    '&:hover': { borderColor: '#042f23 !important' },
    '&:focus': { border: '#0a7559bf solid .15rem !important' },
    '&::placeholder, -ms-input-placeholder, -ms-input-placeholder': { color: '#cdcdcd !important' }
  }
}));
